import quote from "./images/quote.png";
import logo from "./images/logo.svg";
import atomByViderLogo from "./images/atomByViderLogo.png";
import loginBg from "./images/login_bg.png";
import whiteLogo from "./images/white_logo.svg";
import dashboard from "./icons/dashboard.svg";
import taskboard from "./icons/taskboard.svg";
import calendar from "./icons/calendar.svg";
import checklist_PosterImage from "./icons/checklist_PosterImage.png";
import handshake_PosterImage from "./icons/handshake_PosterImage.png";
import socialmedia_PosterImage from "./icons/socialmedia_PosterImage.png";
import calendar_PosterImage from "./icons/calendar_PosterImage.png";
import taskCompleted from "./icons/taskCompleted.svg";
import totalClients from "./icons/totalClients.svg";
import taskInprogress from "./icons/taskInprogress.svg";
import taskTodo from "./icons/taskTodo.svg";
import taskUnderReview from "./icons/taskUnderReview.svg";
import totalTasks from "./icons/totalTasks.svg";
import invoicing from "./icons/invoicing.svg";
import clients from "./icons/clients.svg";
import storage from "./icons/storage.svg";
import team from "./icons/team.svg";
import reports from "./icons/reports.svg";
import settings from "./icons/settings.svg";
import broadcast from "./icons/broadcast.svg";
import logout from "./icons/logout.svg";
import man from "./icons/man.svg";
import profile from "./icons/profile.svg";
import date from "./icons/calendar.png";
import shuffle from "./icons/shuffle.svg";
import formIcon from "./icons/formIcon.svg";
import empty from "./images/empty.svg";
import user from "./icons/user.png";
import folder from "./icons/folder.png";
import pdf from "./icons/filetypes/pdf.png";
import doc from "./icons/filetypes/docs.png";
import excel from "./icons/filetypes/excel.png";
import csv from "./icons/filetypes/csv.png";
import text from "./icons/filetypes/text.png";
import ppt from "./icons/filetypes/ppt.png";
import zip from "./icons/filetypes/zip.png";
import video from "./icons/filetypes/video.png";
import audio from "./icons/filetypes/audio.png";
import recurring from "./icons/recurring.svg";
import singleLine from "./icons/singleLine.svg";
import email from "./icons/email.svg";
import address from "./icons/address.svg";
import multiLine from "./icons/multiLine.svg";
import name from "./icons/name.svg";
import checkBox from "./icons/checkBox.svg";
import fileUpload from "./icons/fileUpload.svg";
import imageUpload from "./icons/imageUpload.svg";
import termsAndConditions from "./icons/termsAndConditions.svg";
import currency from "./icons/currency.svg";
import signature from "./icons/signature.svg";
import dropDown from "./icons/dropDown.svg";
import decisionBox from "./icons/decisionBox.svg";
import fieldDate from "./icons/date.svg";
import mobileNumber from "./icons/mobileNumber.svg";
import numbers from "./icons/number.svg";
import profileImage from "./images/profile.jpg";
import noAttachments from "./images/no_attachments.svg";
import noSubTasks from "./images/noSubTasks.svg";
import noChecklists from "./images/noChecklists.svg";
import noMilestones from "./images/noMilestones.svg";
import noDueDiligence from "./images/noDueDiligence.svg";
import noEvents from "./images/noEvents.svg";
import signup from "./images/signup.png";
import newlogo from "./images/newlogo.png";
import emptyLicenses from "./images/emptyLicenses.png";
import createFormLanding from "./images/createFormLanding.png";
import clientFormCard from "./images/clientFormCard.png";
import file from "./icons/file.png";
import atom_logo from "./images/atom_logo.png";
import onedrive from "./icons/onedrive.png";
import folderIcon from "./icons/folder.svg";
import emptyGroup from "./images/GroupEmpty.png";
import quantum_logo from "./images/Quantum_logo.png";
import quantum from "./images/Quantum.png";
import quantum_signup from "./images/quantum_signup.png";
import quantum_white from "./images/quantum_white.png";
import quantumSmall from "./images/quantum-small.png";
import quantumLogin from "./images/quantum-login.png";
import quantumLogin1 from "./images/quantumLogin1.png";
import viderlogo from "./images/viderlogo.png";
import video1 from "./images/video.mp4";
import agreement from "./images/Agreement document.mp4";
// import signyourself from "./images/sign-yourself.jpg"

import eSign from "./images/cartoon-pen.jpg";
import prefill from "./images/normal-remove.png";
import documentDrafting from "./images/normal-removebg-preview.png";
import BellWithNotification from "./images/calendar-with-bell.png";
import AtomNew from "./images/Atom_logo1.jpeg";
import RendaringGraphic from "./images/web-page-isometric.png";
import signyourself from "./images/signyourself.png";
import sendforothers from "./images/sendforothers.jpg";
import warningSign from "./images/warning-sign.jpg";

export {
  quote,
  logo,
  loginBg,
  whiteLogo,
  empty,
  profileImage,
  noAttachments,
  noSubTasks,
  noChecklists,
  noMilestones,
  noDueDiligence,
  noEvents,
  signup,
  newlogo,
  emptyLicenses,
  createFormLanding,
  clientFormCard,
  atom_logo,
  emptyGroup,
  atomByViderLogo,
  quantum_logo,
  quantum,
  quantum_signup,
  quantum_white,
  quantumSmall,
  quantumLogin,
  quantumLogin1,
  viderlogo,
  video1,
  agreement,
  eSign,
  prefill,
  documentDrafting,
  RendaringGraphic,
  BellWithNotification,
  AtomNew,
  signyourself,
  sendforothers,
  warningSign,
};

export const icons = {
  totalTasks,
  totalClients,
  taskCompleted,
  taskInprogress,
  taskTodo,
  taskUnderReview,
  checklist_PosterImage,
  handshake_PosterImage,
  socialmedia_PosterImage,
  calendar_PosterImage,
  folder,
  dashboard,
  taskboard,
  calendar,
  reports,
  invoicing,
  team,
  storage,
  settings,
  clients,
  broadcast,
  logout,
  man,
  profile,
  date,
  shuffle,
  user,
  pdf,
  doc,
  excel,
  csv,
  text,
  ppt,
  zip,
  video,
  audio,
  recurring,
  formIcon,
  singleLine,
  multiLine,
  email,
  name,
  fileUpload,
  imageUpload,
  termsAndConditions,
  currency,
  signature,
  dropDown,
  decisionBox,
  mobileNumber,
  numbers,
  fieldDate,
  checkBox,
  address,
  file,
  onedrive,
  folderIcon,
};
